import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useLabels } from 'wsm-common-data';

const NoResults = ({
	hasNoResults,
	hasNoInventoryResults,
	searchTerm,
	isParamSearch,
	hasCompleteResults,
	triggerTrackingEvent
}) => {
	const labels = useLabels();
	const { noResultsVerbiageLabel } = usePrefs();

	const message = noResultsVerbiageLabel
		? labels.get(noResultsVerbiageLabel)
		: `${labels.get('NO_RESULTS_FOR')} "${searchTerm}".`;

	useEffect(() => {
		// URL param search in embedded display after inventory, page and content results are returned
		if (isParamSearch && hasCompleteResults) {
			if (hasNoResults) {
				triggerTrackingEvent({
					element: 'No search results',
					action: 'impression',
					result: 'No results message presented',
					fieldValue: searchTerm,
					nonInteractive: true
				});
			} else if (hasNoInventoryResults) {
				triggerTrackingEvent({
					element: 'No inventory results',
					action: 'impression',
					result: 'No inventory results presented',
					fieldValue: searchTerm,
					nonInteractive: true
				});
			}
		}
	}, [
		hasCompleteResults,
		hasNoInventoryResults,
		hasNoResults,
		isParamSearch,
		searchTerm,
		triggerTrackingEvent
	]);

	return hasNoResults ? (
		<div className="error p-4 border-bottom">{message}</div>
	) : null;
};

NoResults.propTypes = {
	hasNoResults: PropTypes.bool.isRequired,
	hasNoInventoryResults: PropTypes.bool.isRequired,
	searchTerm: PropTypes.string.isRequired,
	isParamSearch: PropTypes.bool.isRequired,
	hasCompleteResults: PropTypes.bool.isRequired,
	triggerTrackingEvent: PropTypes.func.isRequired
};

export default NoResults;
